import React, { useCallback, useMemo } from 'react'
import { Popover } from 'antd'

import { clearTagFilters } from '../../../Slices/Kiosk/TableOptionsSlice'
import { populateTableWithArticles } from '../../../Services/Kiosk/ArticleServices'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import { renderTranslation } from '../../../Helpers/GenericHelpers'
import ExtraClearFilterIcon from '../../Svg/ExtraClearFilterIcon'
import { getSearchedTableFiltersValue, retrieveActiveEmptyColumns } from '../../../Helpers/FilterHelper'
import { ModelKey } from '../../../Constants/Configuration'
import { ArticleColumn } from '../../../Constants/TableConfiguration'
import { populateSubRuleTableWithArticles } from '../../../Services/Omnichannel/SeasonRuleService'
import { clearSubRuleTagFilters } from '../../../Slices/Omnichannel/SubRuleSlice'
import { useAppDispatch, useAppSelector } from '../../../hooks'

function ClearFilters(props) {
  const dispatch = useAppDispatch()
  const language = useAppSelector(state => state.present.language.value)
  const tableColumns = useAppSelector(state =>
    props.isFromDiWa ? state.present.tableOptions.tableColumns : state.present.subRule.filterColumns,
  )
  const emptyTableColumns = useAppSelector(state =>
    props.isFromDiWa ? state.present.tableOptions.emptyTableColumns : state.present.subRule.emptyFilterColumns,
  )
  const emptyExtraDescriptions = useAppSelector(state =>
    props.isFromDiWa ? state.present.tableOptions.emptyExtraDescriptions : [],
  )
  const negateTableColumns = useAppSelector(state =>
    props.isFromDiWa ? state.present.tableOptions.negateTableColumns : state.present.subRule.negateColumns,
  )
  const tableFilters = useAppSelector(state =>
    props.isFromDiWa ? state.present.tableOptions.tableFilters : state.present.subRule.tableFilters,
  )
  const priceFilter = useAppSelector(state => (props.isFromDiWa ? state.present.tableOptions.priceFilter : {}))

  const currentConfiguration = useAppSelector(state => state.present.configuration.currentConfiguration)
  const allMarketplace = useAppSelector(state => state.present.configuration.allMarketplace)
  const serverConfig = useAppSelector(state => state.present.article.serverConfig)
  const userValue = useAppSelector(state => state.present.configuration.userValue)
  const publicWorkspace = useAppSelector(state => state.present.configuration.publicWorkspace)

  const clearFilters = useCallback(() => {
    if (props.isFromDiWa) {
      dispatch(
        clearTagFilters({
          configurationName: currentConfiguration,
          user: userValue,
          serverConfig: serverConfig,
          publicWorkspace: publicWorkspace,
        }),
      )
      dispatch(populateTableWithArticles())
    } else {
      dispatch(clearSubRuleTagFilters(currentConfiguration))
      dispatch(populateSubRuleTableWithArticles(false))
    }
  }, [props.isFromDiWa, dispatch, currentConfiguration, userValue, serverConfig])

  const emptyColumns = useMemo(() => {
    const empty = retrieveActiveEmptyColumns(emptyTableColumns, emptyExtraDescriptions)
    return empty
  }, [emptyTableColumns, emptyExtraDescriptions])

  const searchedColumns = useMemo(() => {
    const filterSearched = getSearchedTableFiltersValue(
      tableColumns,
      tableFilters,
      negateTableColumns,
      priceFilter,
      allMarketplace,
    )
    return filterSearched
  }, [tableColumns, tableFilters, negateTableColumns, priceFilter, allMarketplace])

  const enableClearFilter = useMemo(() => {
    return props.isFromDiWa
      ? emptyColumns.length !== 0 ||
          searchedColumns.length !== 0 ||
          negateTableColumns.length !== 0 ||
          tableFilters[ModelKey] ||
          tableFilters[ArticleColumn.TableKey]
      : emptyColumns.length !== 0 ||
          searchedColumns.filter(x => x !== ArticleColumn.Season).length !== 0 ||
          negateTableColumns.length !== 0 ||
          tableFilters[ModelKey] ||
          tableFilters[ArticleColumn.TableKey]
  }, [props.isFromDiWa, emptyColumns.length, searchedColumns, negateTableColumns.length, tableFilters])

  return enableClearFilter ? (
    <Popover content={renderTranslation(language, TranslationKeys.clearFilterTips)} trigger='hover'>
      <span className='icon-block'>
        <ExtraClearFilterIcon className={'generic-icon general-clear-icon'} onClick={clearFilters} />
      </span>
    </Popover>
  ) : null
}

export default ClearFilters
